const $window = $(window);

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

//ヘッダー開閉
import {headerToggle} from "../include/module";
headerToggle();

//動画モーダル
import {showMovie} from "../include/module";
showMovie();

//プロフィールモーダル
import {showprofile} from "../include/module";
showprofile();

//音楽再生
import {playAudio} from "../include/module";
playAudio();

import {scrollAnimation} from "../include/module";

$(window).on('load', function(){
  setTimeout(function () {
    scrollAnimation();
    mainslider();
  }, 100);
});

$(window).on('scroll', function(){
  scrollAnimation();
});

const swiper = new Swiper('.index-Bnr_Slider', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  allowTouchMove: true,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

const mainslider = () => {
  const kvswiper = new Swiper('.kv-Slider', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    loopAdditionalSlides: 1,
    effect: 'fade',
    grabCursor: true,
    speed: 1000,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });
};

// ------------------------------------------------------------------------
// change_btn
// ------------------------------------------------------------------------
const changebtn = () => {
  const $btn = $('.change');
  const $kv = $('#kv');
  $btn.on('click', function(){
    $kv.toggleClass('changed');
  });
};
changebtn();



// WEBPACK FOOTER //
// ./src/assets/js/index/script.js